// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.field-separation:not(:first-child) {\n  border-top: 1px solid #EDEDED;\n  padding: 1rem 0 0 0;\n  margin-bottom: 0;\n  margin-top: 0.2rem;\n}\n.field-separation:last-child {\n  margin-bottom: 1rem;\n}\n.field-separation small,\n.separator .field small{\n  font-size: 0.6em;\n}\n", ""]);
// Exports
module.exports = exports;
